import React from 'react';

import Table from 'components/shared/Table';

import useProposalsTable from './functions';
import s from './index.module.css';

const LIMITS_RANGE = [3, 10, 25, 50, 100];

function ProposalsTable({ items, pagination, columns, onChangePageQueryParams }) {
  const { limit, handleLimitChange, setPage } = useProposalsTable({ onChangePageQueryParams });

  return (
    <Table
      columns={columns}
      data={items}
      pagination={pagination}
      limit={limit}
      limitsRange={LIMITS_RANGE}
      onSelectPage={setPage}
      onLimitChange={handleLimitChange}
      tableClassName={s.table}
      noDataText="No proposals for updates"
      withFixSizedColumns
    />
  );
}

export default React.memo(ProposalsTable);
